module.exports = "/images/Artboard7.png?9e9c51399de7c24ceaaf4b93129c389c";